import React from 'react';
import { Box } from '@components/Box';
import { Text } from '@components/typography';
import { CloudImage } from '@components/CloudImage';
import {
  StoryWrapper,
  GradientBlobBox,
  BlobBox,
  StyledStoriesPara,
  SignatureImageBox,
  SignatureImage,
  PersonFlex,
  PersonNameText,
  StoryPersonImageWrapper,
} from './OurStorySection.styles';
import { useTranslation } from 'react-i18next';

export const OurStorySectionContent = () => {
  const { t } = useTranslation('ourStory');
  const ourStorySection = t('ourStorySection');
  return (
    <>
      <GradientBlobBox>
        <CloudImage src="our-story/story/gradient-blob-bg-v2.svg" width="100%" height="100%" optimization="aggressive" />
      </GradientBlobBox>
      <BlobBox>
        <CloudImage resizeWidth={275} src="our-story/story/blob-bg-v2.jpg" width="100%" height="100%" optimization="aggressive" />
      </BlobBox>
      <StoryWrapper>
        <Text variant="hed56" tagName="h2" color="neutra6" marginBottom={[6, 7]}>
          {ourStorySection.title}
        </Text>
        {ourStorySection.stories.map((item, index) => (
          <StyledStoriesPara key={index} variant="dek20" tagName="p" color="neutra6" marginBottom={[5]}>
            {item}
          </StyledStoriesPara>
        ))}
        <Text variant="dek20" color="neutra5" tagName="p">
          {ourStorySection.sincerely}
        </Text>
        <SignatureImageBox marginY={[6]}>
          <SignatureImage resizeWidth={220} src="our-story/story/vishal-joshi-signature.png" optimization="aggressive" />
        </SignatureImageBox>
        <PersonFlex alignItems="center">
          <StoryPersonImageWrapper>
            <CloudImage
              resizeWidth={66}
              src="our-story/story/vishal-avatar.jpg"
              alt="story person image"
              width="100%"
              height="100%"
              optimization="aggressive"
            />
          </StoryPersonImageWrapper>
          <Box paddingLeft={[4, 4]}>
            <PersonNameText variant="featureHed17" tagName="span" color="neutra6">
              <span>{`${ourStorySection.storyPerson}, `}</span> <span className="designation">{`${ourStorySection.designation}`}</span>
            </PersonNameText>
          </Box>
        </PersonFlex>
      </StoryWrapper>
    </>
  );
};
